module.exports = __webpack_public_path__ + "img/high-tier-poster-board.286b5836.jpg";